import React from 'react';
import style from '@theme/js/components/main/SmsVerification/index.scss';
import { SmsVerificationStepType } from '@theme/js/components/main/SmsVerification/';
import { VERIFICATION_TYPES } from '@theme/js/components/main/SmsVerification/constants';
import { useTranslations } from '@core/js/hooks/i18n';

const SuccessStep = React.memo(({ onClose, type }: SmsVerificationStepType) => {
    const isDefaultVerification = type === VERIFICATION_TYPES.DEFAULT;
    const iconCls = isDefaultVerification ? style.successIcon : style.successBonusIcon;
    const postfix = isDefaultVerification ? '' : '.incent';
    const t = useTranslations('playtech.mobile.system.verification.success.');

    return (
        <>
            <div className={`${style.icon} ${iconCls}`}></div>
            <div className={style.message}>{t(`message${postfix}`)}</div>
            <div className={style.description}>
                {t(`description${postfix}`)}
            </div>
            {!isDefaultVerification && (
                <div className={style.description}>
                    {t('description2.incent')}
                </div>
            )}
            <div className={style.phoneNumber}>{t('thanks')}</div>
            <button onClick={onClose} className={style.verificationButton}>
                {t('submit')}
            </button>
        </>
    );
});

export default SuccessStep;
